import React from "react";
import Button, { ButtonSize, ButtonType } from "src/components/Button";
import { ReactComponent as ArrowDownIcon } from "src/assets/icons/ic-24-arrow-bottom.svg";
import { ReactComponent as ArrowUpIcon } from "src/assets/icons/ic-24-arrow-up.svg";
import { observer } from "mobx-react";
import { observable, action } from "mobx";
import Popover from "src/components/Popover";
import DropDownFilterMenu from "src/components/DropDownMenu";
import styles from "./DropDownFilter.module.css";
import cn from "classnames";
import { IFilterItemSnapshotIn } from "src/models/FilterItem";

interface DropDownFilterProps {
  items: IFilterItemSnapshotIn[];
  disabled?: boolean;
  buttonClassName?: string;
  menuClassName?: string;
  popoverSpacerClassName?: string;
  onChange: (value: IFilterItemSnapshotIn) => void;
  defaultItem: IFilterItemSnapshotIn;
}

@observer
class DropDownFilter extends React.Component<DropDownFilterProps> {
  private filterRef = React.createRef<HTMLButtonElement>();

  @observable
  private selectedItem: IFilterItemSnapshotIn = this.props.defaultItem;

  @observable
  private popoverIsOpen: boolean = false;

  @action
  private openPopover = () => {
    this.popoverIsOpen = true;
  };

  @action
  private closePopover = () => {
    this.popoverIsOpen = false;
  };

  @action
  private onSelectItem = (selectedItem: IFilterItemSnapshotIn) => {
    this.selectedItem = selectedItem;
    this.closePopover();
    this.props.onChange(selectedItem);
  };

  private renderPopover = () => (
    <Popover
      open={this.popoverIsOpen}
      onClose={this.closePopover}
      anchor={this.filterRef}
      placement="bottom-start"
    >
      <div
        className={cn(
          styles.popover__spacer,
          this.props.popoverSpacerClassName
        )}
      />
      <DropDownFilterMenu
        items={this.props.items}
        selected={this.selectedItem}
        onSelectItem={this.onSelectItem}
        className={this.props.menuClassName}
      />
    </Popover>
  );

  public render() {
    const { disabled, buttonClassName } = this.props;

    return (
      <>
        <Button
          className={buttonClassName}
          size={ButtonSize.SMALL_WIDE}
          buttonType={ButtonType.HALF_COLORED}
          disabled={disabled}
          endIcon={this.popoverIsOpen ? ArrowUpIcon : ArrowDownIcon}
          ref={this.filterRef}
          onClick={this.popoverIsOpen ? this.closePopover : this.openPopover}
          type="button"
        >
          {this.selectedItem.name}
        </Button>
        {this.renderPopover()}
      </>
    );
  }
}

export default DropDownFilter;
